// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"DetailsComponent_mainCont__22gPy","img1":"DetailsComponent_img1__1mmUX"};